// import {KTSVG} from '../../../../../../_metronic/helpers'
import { KTSVG } from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const CartypeEditModalHeader = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      {/* <h2 className='fw-bolder'>Add Cartype</h2> */}
      <h2 className='fw-bolder '>{itemIdForUpdate ? "Edit" : "Add"} Car Type</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-cartypes-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {CartypeEditModalHeader}
